import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { WarningAmber as WarningIcon } from '@mui/icons-material';
import { appColors } from '../../Config/Theme';

interface NeedsAttentionBannerProps {
  notAccountedCount: number;
  onReviewClick: () => void;
}

const NeedsAttentionBanner: React.FC<NeedsAttentionBannerProps> = ({ notAccountedCount, onReviewClick }) => {
  if (notAccountedCount <= 0) return null;

  return (
    <Box
      role="alert"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1,
        bgcolor: '#FFF3E0',
        border: `1px solid ${appColors.status.warning}`,
        borderRadius: '8px',
        my: 1,
      }}
    >
      <WarningIcon sx={{ fontSize: 20, color: appColors.status.warning, flexShrink: 0 }} />
      <Typography variant="body2" sx={{ color: appColors.text.heading, fontWeight: 600, flex: 1 }}>
        Needs attention: {notAccountedCount} {notAccountedCount === 1 ? 'person' : 'people'} marked Not Accounted
      </Typography>
      <Button
        size="small"
        variant="outlined"
        onClick={onReviewClick}
        sx={{
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.8rem',
          borderColor: appColors.status.warning,
          color: appColors.status.warning,
          '&:hover': { borderColor: appColors.status.warning, bgcolor: '#FFF8E1' },
        }}
      >
        Review Not Accounted
      </Button>
    </Box>
  );
};

export default React.memo(NeedsAttentionBanner);
